// extracted by mini-css-extract-plugin
export default {"group":"KPIFormatSelect_group__RnADK","button":"KPIFormatSelect_button__cLHPZ","selected":"KPIFormatSelect_selected__4st3x"};